import api from '@/utils/api';

/**
 * delete company option
 *
 * @param {string} companyId - The company id
 * @param {string} id - The option id
 * @returns {Promise} The promise object of the api call
 */
const deleteCompanyOptionApi = (companyId, id) =>
  api.delete(`company/${companyId}/option/${id}`);

export default deleteCompanyOptionApi;
